import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import uuidV4 from 'uuid/v4';
import Notification from '../../components/Notification';
import UpgradeRequired from "../../components/UpgradeRequired";
import Select from 'react-select';
import Switch from 'rc-switch';

class Abtest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading:true,
            isError:false,
            test:{
                'id':0,
                'description':'',
                'email_id_a':0,
                'email_id_b':0,
                'status':false,
            },
            emails:[],
            isLoadingA:true,
            isLoadingB:false,
        }
        this.handleNameChange = this.handleNameChange.bind(this);
        this.buildA = this.buildA.bind(this);
        this.onChangeA = this.onChangeA.bind(this);
        this.onChangeB = this.onChangeB.bind(this);
        this.renderSelectB = this.renderSelectB.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.save = this.save.bind(this);


    }

    save() {
        if(this.state.test.description == '') {
            Notification.error('You need to give this test a name.');
            return false;
        }

        this.setState({
            isLoading:true,
        });

        let method = 'post';
        let url = '/emails/abtests';

        if(this.props.testId) {
            method = 'put';
            url += '/'+this.props.testId;
        }

        axios[method](url,this.state.test).then(res => {
            Notification.success('Test saved');
            this.setState({
                isLoading:false,
            })

            this.props.handleSave(res.data);
            this.props.onClose();
        });
    }

    handleStatusChange(value) {
        let val = (value == true ? 1:0);

        if(val == 1 && (this.state.test.email_id_a == 0 || this.state.test.email_id_b == 0)) {
            Notification.error('You must select A and B e-mail before you can activate the test');
            return;
        }

        this.setState({
            ...this.state,
            test:{
                ...this.state.test,
                status:val,
            }
        });
    }

    renderSelectB() {

        let type = '';

        for(let i in this.state.emails) {
            if(this.state.emails[i].id == this.state.test.email_id_a) {
                type = this.state.emails[i].type;
            }
        }

        return (
            <select className="form-control" onChange={this.onChangeB} value={this.state.test.email_id_b} disabled={this.state.test.email_id_a == 0 ? true:false}>
                <option value={0}>Select an e-mail to test</option>
                {
                    this.state.emails.map(item => {
                        return (!this.props.testId && item.isAbtesting) || (this.props.testId && item.isAbtesting && item.id !== this.state.test.email_id_b) || item.type != type || item.id == this.state.test.email_id_a ? null:<option key={item.id} value={item.id}>#{item.id} - {item.subject}</option>;
                    })
                }
            </select>
        )
    }

    handleNameChange(e) {
        this.setState({
            ...this.state,
            test:{
                ...this.state.test,
                description:e.target.value,
            }
        });
    }

    onChangeB(e) {
        this.setState({
            ...this.state,
            test:{
                ...this.state.test,
                email_id_b:parseInt(e.target.value),
            }
        })
    }

    onChangeA(e) {
        this.setState({
            ...this.state,
            test:{
                ...this.state.test,
                email_id_a:parseInt(e.target.value),
                email_id_b:0,
                status:0,
            }
        })
    }

    buildA() {
        return [];
    }


    componentWillMount() {
        axios.get('/emails').then(res => {
            let emails = res.data;

            if(this.props.testId) {
                axios.get(`/emails/abtests/${this.props.testId}`)
                    .then(res => {
                        this.setState({
                            'isLoading':false,
                            emails:emails,
                            test:res.data,
                        });
                    })
                    .catch(res => {
                        this.setState({'isError':'Segment not found'});
                    });
            }else{
                this.setState({
                    emails:res.data,
                    isLoading:false,
                });
            }

        });
    }

    render() {

        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }
        {console.dir(this.state)}
        return (
            <div className="overview m-t-30 col-sm-8 offset-sm-2 text-center">
                <h1>A/B test</h1>
                <h2>This will create a A/B split test to see which of your e-mails perform the best.<br />
                    A/B split test allows you to send two different versions of the same e-mail.</h2>
                <div className="m-t-40 col-sm-12">
                    <div className="m-b-20 strike">
                        <span>Description</span>
                    </div>
                    <div className="col-sm-12 p-0 offset-sm-0">
                        <input type="text" onChange={this.handleNameChange} className="form-control form-control-lg" value={this.state.test.description} placeholder="Give this test a description." />
                    </div>
                </div>

                <div className="m-t-40 col-sm-6">
                    <div className="m-b-20 strike">
                        <span>E-mail A</span>
                    </div>
                    <select className="form-control" onChange={this.onChangeA} value={parseInt(this.state.test.email_id_a)}>
                        <option value={0}>Select an e-mail to test</option>
                        {
                            this.state.emails.map(item => {
                                return (!this.props.testId && item.isAbtesting) || (this.props.testId && item.isAbtesting && item.id !== this.state.test.email_id_a) || item.type == 'TEMPLATE' ? null:<option key={item.id} value={parseInt(item.id)}>#{item.id} - {item.subject}</option>;
                            })
                        }
                    </select>
                </div>

                <div className="m-t-40 col-sm-6">
                    <div className="m-b-20 strike">
                        <span>E-mail B</span>
                    </div>
                    {this.renderSelectB()}
                </div>

                <div className="m-t-40 col-sm-12">
                    <div className="m-b-20 strike">
                        <span>Test status</span>
                    </div>
                    <div className="col-sm-10 offset-sm-1">
                        <div>
                            <div className="col-sm-4 text-right">
                                Activate test
                            </div>

                            <div className="col-sm-6 text-right">
                                <Switch onChange={this.handleStatusChange}
                                        checked={(this.state.test.status == 1 ? true:false)}
                                        checkedChildren={<i className="icon fa-check"></i>}
                                        unCheckedChildren={<i className="icon fa-close"></i>}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 m-t-40 m-b-40 offset-sm-0">
                    {
                        this.props.enabled == '0' ? <UpgradeRequired message="If you want to use A/B tests, you need to upgrade your account to a larger package" />
                            :
                            <button type="button" onClick={this.save} className="btn btn-dark btn-block">Save</button>
                    }
                </div>





            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


Abtest = connect(mapStateToProps,mapDispatchToProps)(Abtest);
export default Abtest;


// WEBPACK FOOTER //
// ./containers/emails/abtest.js